var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37.6667C18.3812 37.6666 17.7878 37.4206 17.3504 36.983L1.01703 20.6497C0.579599 20.2121 0.333862 19.6187 0.333862 19C0.333862 18.3813 0.579599 17.7879 1.01703 17.3504L17.3504 1.01703C17.5656 0.79417 17.8231 0.616411 18.1078 0.494124C18.3924 0.371836 18.6986 0.307468 19.0084 0.304776C19.3182 0.302083 19.6255 0.36112 19.9123 0.478442C20.199 0.595764 20.4595 0.769022 20.6786 0.988105C20.8977 1.20719 21.071 1.46771 21.1883 1.75447C21.3056 2.04123 21.3646 2.34848 21.3619 2.6583C21.3593 2.96811 21.2949 3.27429 21.1726 3.55897C21.0503 3.84365 20.8726 4.10112 20.6497 4.31636L5.96603 19L20.6497 33.6837C20.9759 34.01 21.1981 34.4257 21.2881 34.8783C21.378 35.3308 21.3318 35.7999 21.1553 36.2262C20.9787 36.6525 20.6797 37.0169 20.2961 37.2733C19.9125 37.5297 19.4614 37.6666 19 37.6667Z",
    fill: "#15345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.49b35824fe9f4970a12d23a06edaca7a.svg";
export { ForwardRef as ReactComponent };